export default __webpack_public_path__ + "static/media/bike-sharing.ad6aef82.svg";